import { Actions, actionSuccessName } from '../actions'
import merge from 'deepmerge'

const _resetEntities = () => ({
   users: {},
   agendas: {},
   appointments: {},
   professionals: {},
   offices: {},
   reports: {},
})

const initialState = {
   _entities: _resetEntities(),
   agendas: [],
   appointmentsFromWeek: [],
   folderMenus: [],
   loggedUser: null,
   selectedAgenda: null,
   teleHealthAppointmentCredentials: null,
}

const data = (state = initialState, action) => {

   let _entities
   if (action.response && action.response.entities) _entities = merge(state._entities, action.response.entities)

   switch (action.type) {

      case actionSuccessName(Actions.GET_USER):
         return {
            ...state, _entities,
            loggedUser: action.response.result
         }

      case actionSuccessName(Actions.GET_AGENDAS):
         return {
            ...state, _entities,
            agendas: action.response.result
         }

      case Actions.SELECT_AGENDA:
         return {
            ...state,
            selectedAgenda: action.payload.id
         }

      // When only merging the entity is enough
      case actionSuccessName(Actions.GET_AGENDA_REPORT):
      case actionSuccessName(Actions.CLOSE_APPOINTMENT):
      case actionSuccessName(Actions.CLOSE_ALL_APPOINTMENTS_FOR_DAY):
      case actionSuccessName(Actions.OPEN_APPOINTMENT):
      case actionSuccessName(Actions.COMPLETE_APPOINTMENT):
      case actionSuccessName(Actions.CANCEL_APPOINTMENT):
         return { ...state, _entities }

      // TODO: considering that every appointment creation is inside the "TimeslotWeeklyView", so we add the new appointment to the week
      case actionSuccessName(Actions.CREATE_APPOINTMENT):
         const afw = [...state.appointmentsFromWeek, action.response.result]
         return {
            ...state, _entities,
            appointmentsFromWeek: afw
         }

      case actionSuccessName(Actions.GET_AGENDA_WEEK_APPOINTMENTS):
         return {
            ...state, _entities,
            appointmentsFromWeek: action.response.result
         }

      case actionSuccessName(Actions.GET_TELEHEALTH_APPOINTMENT_CREDENTIALS):
         return {
            ...state,
            teleHealthAppointmentCredentials: {
               credentials: action.response.data,
               status: action.response.status,
               statusText: action.response.statusText,
            }
         }

      case Actions.CLEAR_TELEHEALTH_APPOINTMENT_CREDENTIALS:
         return {
            ...state,
            teleHealthAppointmentCredentials: null
         }

      case Actions.LOG_IN_REQUEST_LOADING:
      case Actions.LOG_IN_REQUEST_ERROR:
      case Actions.LOG_OUT:
         return {
            _entities: _resetEntities(),
            agendas: [],
            appointmentsFromWeek: [],
            folderMenus: [],
            loggedUser: null,
            selectedAgenda: null,
            teleHealthAppointmentCredentials: null,
         }

      default:
         return state
   }
}

export default data



// WEBPACK FOOTER //
// ./src/state/reducers/data.js